import React, { useEffect, useState } from "react";
import { getBegabungKonzeptPage } from "../lib/api";
import {
  Page,
  PageHeader,
  Section,
  SectionHead,
  IntroSplit,
  CardGrid,
  IconCard,
} from "../components/ui";

export default function BegabungKonzeptPage() {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    getBegabungKonzeptPage()
      .then((res) => !cancelled && setData(res))
      .catch((err) => !cancelled && setError(err));
    return () => {
      cancelled = true;
    };
  }, []);

  const {
    heroTitle,
    heroSubtitle,
    heroImages,
    introKicker,
    introTitle,
    introText,
    sectionTitle,
    sectionSubtitle,
    cards,
  } = data || {};

  return (
    <Page loading={!data} error={error}>
      <PageHeader
        parent={{ label: "Begabungsförderung", to: "/" }}
        current="Konzept & Ziele"
        title={heroTitle}
        subtitle={heroSubtitle}
      />

      <Section intro>
        <IntroSplit images={heroImages} kicker={introKicker} title={introTitle} text={introText} />
      </Section>

      <Section>
        <SectionHead title={sectionTitle} subtitle={sectionSubtitle} />

        <CardGrid cols={3}>
          {(cards || []).map((card, i) => (
            <IconCard key={card.id ?? i} iconName={card.iconName} title={card.title} text={card.text} />
          ))}
        </CardGrid>
      </Section>
    </Page>
  );
}